import { useTranslation } from 'react-i18next';

/** «Дневник» — единая лента дня. Этап 0: каркас. */
export function DiaryScreen(): JSX.Element {
  const { t } = useTranslation();
  return (
    <main className="screen">
      <h1 className="type-h1 screen-title">{t('diary.title')}</h1>
      <section className="card">
        <p className="type-body-15 muted" style={{ margin: 0 }}>
          {t('diary.empty')}
        </p>
      </section>
    </main>
  );
}
